<template>
  <div>
    <topbar :showBack="true" :largeTitle="true" :title="$t('quiz.leaderboard')" color="purple" @back="$emit('close')"/>

    <div class="max-w-6xl mx-auto w-full xl:mt-4">
      <card type="square" class="xl:rounded-lg overflow-hidden">
        <leaderboard-badge :rank="i + 1" :award="award" v-for="(award, i) in leaderboard" :key="award.id" />
      </card>

      <div v-if="myrank && myrank > 5">
        <p class="p-2 pt-4">La tua posizione</p>
        <card type="square" class="xl:rounded-lg overflow-hidden">
          <leaderboard-badge :rank="myrank" :award="award" />
        </card>
      </div>
    </div>

  </div>
  
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LeaderboardBadge from '@/components/quizzes/LeaderboardBadge'

export default {
  components: {
    LeaderboardBadge
  },
  props: {
    quiz: String,
  },
  data() {
    return {
    }
  },

  computed: {
    ...mapState('quiz', ['leaderboard', 'award']),
    ...mapGetters('quiz', ['myrank'])
  },
}
</script>

<style>

</style>